import { useBaseApiQuery } from "@query/baseQuery";
import * as tokenService from "@service/tokenService"

export const useRefreshTokenOnStartQuery = () => {
    const _refreshToken = tokenService.getRefreshToken();

    return useBaseApiQuery({
        method: "POST",
        endpoint: "/auth/refresh-tokens",
        data: {refresh_token: _refreshToken}
    }, {
        staleTime: 0,
        cacheTime: 0,
        retry: false
    });
};